import React from 'react';
import { SubtleText } from '@99designs/emu';
import { formatMessage } from '@99designs/frontend-components/i18n';

export interface DownloadedByProps {
    downloadedBy: { displayName: string }[];
}

function DownloadedBy({ downloadedBy }: DownloadedByProps) {
    return (
        <>
            {downloadedBy.map(({ displayName }) => (
                <span key={displayName}>
                    <SubtleText>
                        {formatMessage(__('Downloaded by {displayName}'), {
                            displayName,
                        })}
                    </SubtleText>
                </span>
            ))}
        </>
    );
}

export default DownloadedBy;
